import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Table,TableContainer,TableHead,TableBody,TableRow,TableCell,TablePagination,Paper,
} from "@mui/material"; 
import { useTranslation } from "react-i18next";

const AssignedTeachers = () => {
  const { t } = useTranslation(); 
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const teachers = [
    { id: 1, name: "Karan", assignedStudents: [] },
    { id: 2, name: "Tushar", assignedStudents: [] },
    { id: 3, name: "Pandey", assignedStudents: [] },
  ];

  const generateStudents = () => {
    const students = [];
    for (let i = 1; i <= 60; i++) {
      const teacherId = (i % 3) + 1;
      students.push({ id: i, name: `Amogh Aspl ${i}`, teacherId });
    }
    return students;
  };

  const [students, setStudents] = useState(generateStudents());

  useEffect(() => {
    setSelectedStudents([]);

    if (selectedTeacher) {
      const initialAssignedStudents = students.filter(
        (student) => student.teacherId === selectedTeacher.id
      );
      setAssignedStudents(initialAssignedStudents);
    } else {
      setAssignedStudents([]);
    }
  }, [selectedTeacher, students]);

  const handleTeacherSelect = (teacher) => {
    setSelectedTeacher(teacher);
  };

  const handleUserRemove = (student) => {
    const updatedSelectedStudents = selectedStudents.filter(
      (selected) => selected.id !== student.id
    );
    setSelectedStudents(updatedSelectedStudents);

    const updatedStudents = students.map((s) =>
      s.id === student.id ? { ...s, teacherId: null } : s
    );
    setStudents(updatedStudents);
  };

  const handlePublish = () => {
    console.log("Selected Teacher:", selectedTeacher);
    console.log("Selected Students:", selectedStudents);
    setSelectedTeacher(null);
    setSelectedStudents([]);
  };

  const getSerialNumber = (index) => {
    return index + 1 + page * rowsPerPage;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const renderTableHeader = () => {
    return (
      <TableHead>
        <TableRow>
          <TableCell align="center">{t("Sr. No.")}</TableCell>
          <TableCell align="center">{t("Name")}</TableCell>
          <TableCell align="center">{t("Class")}</TableCell>
          <TableCell align="center">{t("Roll No.")}</TableCell>
          <TableCell align="center">{t("Father's Name")}</TableCell>
          <TableCell align="center">{t("Father's Mobile Number")}</TableCell>
          <TableCell align="center">{t("Actions")}</TableCell>
        </TableRow>
      </TableHead>
    );
  };

  const renderTableBody = () => {
    return (
      <TableBody sx={{ borderBottom: "none" }}>
        {assignedStudents
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((student, index) => (
            <TableRow key={student.id} sx={{ borderBottom: "none" }}>
              <TableCell align="center" sx={{ borderBottom: "none" }}>{getSerialNumber(index)}</TableCell>
              <TableCell align="center" sx={{ borderBottom: "none" }}>{student.name}</TableCell>
              <TableCell align="center" sx={{ borderBottom: "none" }}>Class X</TableCell>
              <TableCell align="center" sx={{ borderBottom: "none" }}>{student.id}</TableCell>
              <TableCell align="center" sx={{ borderBottom: "none" }}>Nishant Aspl</TableCell>
              <TableCell align="center" sx={{ borderBottom: "none" }}>9593958633</TableCell>
              <TableCell align="center" sx={{ borderBottom: "none" }}>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => handleUserRemove(student)}
                >
                  Remove
                </button>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    );
  };

  return (
    <div className="container-fluid mt-5">
      <h2>Assigned Students</h2>
      <div className="row mt-4">
        <div className="col-md-4">
          <div className="mb-3">
            <label htmlFor="teacherSelect" className="form-label">
              Select Teacher:
            </label>
            <select
              id="teacherSelect"
              className="form-select"
              value={selectedTeacher ? selectedTeacher.id : ""}
              onChange={(e) =>
                handleTeacherSelect(
                  teachers.find(
                    (teacher) => teacher.id === parseInt(e.target.value)
                  )
                )
              }
            >
              <option value="">Select Teacher</option>
              {teachers.map((teacher) => (
                <option key={teacher.id} value={teacher.id}>
                  {teacher.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {selectedTeacher && assignedStudents.length > 0 && (
        <div>
          <h3>Assigned Students for {selectedTeacher.name}:</h3>
          <TableContainer component={Paper} className="my-4">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              {renderTableHeader()}
              {renderTableBody()}
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={assignedStudents.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </div>
      )}

      {selectedTeacher && (
        <button className="btn" id="btn" onClick={handlePublish}>
          Publish Selected Students
        </button>
      )}
    </div>
  );
};

export default AssignedTeachers;